<h2 mat-dialog-title>Add Permit #</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>Permit #</mat-label>
    <!-- Bind maxlength based on permit type: 6 for Open Access, otherwise 4 -->
    <input matInput type="text" inputmode="decimal"
           [attr.maxlength]="data.permitType === 'Open Access' ? 6 : 4"
           [formControl]="number"
           (input)="_forbidNonNumeric(number)"
           (keyup.enter)="confirm()">
    <mat-error *ngIf="number.errors?.pattern || number.errors?.required">
      {{ data.permitType === 'Open Access' ? '6 Digit number required' : '4 Digit number required' }}
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button style="background-color: var(--elog-accent-strong); color: var(--elog-accent-on);" (click)="confirm()">OK</button>
</mat-dialog-actions>
